import React from 'react';
/* eslint-disable space-infix-ops */
const VideoContext = React.createContext(null);
/* eslint-enable space-infix-ops */
export default VideoContext;
export { VideoContext };
